const View = require('public_framework/view')

class ToggleView extends View {
  get events () {
    return {'click @trigger': 'toggle'}
  }

  toggle (e) {
    e.stopPropagation()
    const className = this.$el.data('active-class') || 'is-active'
    this.$el.toggleClass(className)
  }
}

module.exports = ToggleView



// WEBPACK FOOTER //
// ./front/apps/public/shared/components/ui/toggle/views/toggle.js